import {Component, Input} from '@angular/core';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {CheckoutEntryValidationService} from '../../services/checkout-entry-validation.service';

@Component({
  selector: 'dcp-order-table',
  templateUrl: './dcp-order-table.component.html',
  styleUrl: './dcp-order-table.component.scss'
})
export class DcpOrderTableComponent {

  @Input() showPrice: boolean = false;
  @Input() showRemoveAction: boolean = false;
  @Input() showEditAction: boolean = false;
  @Input() entry: OrderEntry;
  @Input() entries: OrderEntry[];
  @Input() entryCount: number;

  constructor(public checkoutEntryValidationService: CheckoutEntryValidationService) {
  }
}
